<template>
    <div>
        <!-- PC -->
        <schoolBusinessPC v-if="!mobile"/>

        <!-- Mobile -->
        <schoolBusinessMobile v-else/>

    </div>
</template>

<script>
    import { mapState } from "vuex";
    import loading from "@/components/loading/loading";
    import schoolBusinessMobile from "@/components/schoolBusiness/mobile/SchoolBusiness";
    import schoolBusinessPC from "@/components/schoolBusiness/pc/SchoolBusiness";

    export default {
        name: "SchoolBusiness",
        components: {
            loading,
            schoolBusinessPC,
            schoolBusinessMobile
        },
        data() {
            return {};
        },
        async mounted() {},
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
            }),
        },
        methods: {},
    };
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/SchoolBusiness/SchoolBusiness_new.vue